import View from './View'
import { ease } from './helpers/EaseHelper'
import { updateSpriteSheet } from './helpers/DOMHelper'
/**
 * class MenuButton
 */

// const COUNT_FRAME_MAX = 55
const COUNT_FRAME_STATIC = 20
const COUNT_FRAME_OVER = 40
const COUNT_FRAME_OUT = 54

class AboutButton extends View {

  showHandler (resolve) {
    ease({ value: 0 })
      .to({ value: COUNT_FRAME_STATIC }, 800)
      .onUpdate(o => { updateSpriteSheet(this.view, '361px', o.value) })
      .onComplete(() => {
        this.view.addEventListener('mouseover', this.onOver)
        this.view.addEventListener('mouseout', this.onOut)
        resolve()
      })
      .start()
  }

  hideHandler (resolve) {
    this.view.removeEventListener('mouseover', this.onOver)
    this.view.removeEventListener('mouseout', this.onOut)
    ease({ value: COUNT_FRAME_STATIC })
      .to({ value: 0 }, 300)
      .onUpdate(o => { updateSpriteSheet(this.view, '361px', o.value) })
      .onComplete(() => { resolve() })
      .start()
  }

  onOver = () => {
    ease({ value: COUNT_FRAME_STATIC })
      .to({ value: COUNT_FRAME_OVER }, 600)
      .onUpdate(o => { updateSpriteSheet(this.view, '361px', o.value) })
      .start()
  }

  onOut = () => {
    ease({ value: COUNT_FRAME_OVER })
      .to({ value: COUNT_FRAME_OUT }, 600)
      .onUpdate(o => { updateSpriteSheet(this.view, '361px', o.value) })
      .start()
  }

}

export default AboutButton


// WEBPACK FOOTER //
// ./src/scripts/AboutButton.js